// extracted by mini-css-extract-plugin
export var container = "index-module--container--Vhbyz";
export var nav = "index-module--nav--2nQz7";
export var controls = "index-module--controls--2zNKI";
export var stopIcon = "index-module--stopIcon--1wx7S";
export var currentIndex = "index-module--currentIndex--3IEhU";
export var icon = "index-module--icon--2l2oK";
export var button = "index-module--button--2EQZP";